import { useState, useRef } from "react";
import { useLang } from "@/i18n/LangContext";
import type { AppDetail } from "@/types/api";

interface MediaSectionProps {
  app: AppDetail;
  isMature: boolean;
}

export default function MediaSection({ app, isMature }: MediaSectionProps) {
  const { t } = useLang();
  const [selectedScreenshot, setSelectedScreenshot] = useState<string | null>(null);
  const modalCloseRef = useRef<HTMLButtonElement>(null);

  return (
    <>

      {/* 스크린샷 */}
      {app.screenshots && app.screenshots.length > 0 && (
        <div className="mb-6">
          <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-3">{t.gameDetail.screenshots}</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
            {app.screenshots.slice(0, 6).map((ss) => (
              <button
                key={ss.id}
                onClick={() => !isMature && setSelectedScreenshot(ss.path_full)}
                aria-label={`View screenshot of ${app.name}`}
                className="video-container hover:ring-2 hover:ring-blue-400 hover:ring-offset-2 transition-all"
              >
                <img
                  src={ss.path_thumbnail}
                  alt={`${app.name} screenshot`}
                  width={230}
                  height={130}
                  className={`w-full h-full object-cover${isMature ? " blur-xl" : ""}`}
                  loading="lazy"
                  decoding="async"
                />
                {isMature && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/20">
                    <span className="text-[10px] font-bold text-white bg-red-500/80 px-1.5 py-0.5 rounded">19+</span>
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* 스크린샷 모달 */}
      {selectedScreenshot && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          role="dialog"
          aria-modal="true"
          aria-label={`${app.name} screenshot`}
          onClick={() => setSelectedScreenshot(null)}
          onKeyDown={(e) => {
            if (e.key === "Escape") setSelectedScreenshot(null);
            if (e.key === "Tab") {
              e.preventDefault();
              modalCloseRef.current?.focus();
            }
          }}
        >
          <div className="relative max-w-5xl w-full aspect-video">
            <img
              src={selectedScreenshot}
              alt={`${app.name} screenshot`}
              width={1920}
              height={1080}
              className={`w-full h-full object-contain${isMature ? " blur-xl" : ""}`}
            />
          </div>
          <button
            ref={modalCloseRef}
            autoFocus
            onClick={() => setSelectedScreenshot(null)}
            aria-label="Close"
            className="absolute top-4 right-4 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-xl transition-colors"
          >
            &times;
          </button>
        </div>
      )}
    </>
  );
}
